export default __webpack_public_path__ + "static/media/FichaProjeto.43ba24e3.pdf";